import React from "react";
import { classNames } from "../utils";

type Props = {
  children?: React.ReactNode;
  color?: string;
  className?: string;
  withOverflow?: boolean;
};

export type LeftBorderColors =
  | ("red" | "blue" | "yellow" | "orange" | "default")
  | string;

function colorDotClassByBadgeColor(color: LeftBorderColors = "green") {
  switch (color) {
    case "yellow":
      return "bg-yellow-500";
    case "blue":
      return "bg-sky-500";
    case "orange":
      return "bg-orange-500";
    default:
      return "bg-green-500";
  }
}

const LeftBorderedContainer = ({
  children,
  color,
  className,
  withOverflow = true,
}: Props) => {
  return (
    <div className="flex">
      <div
        data-testid="left-bar"
        className={`rounded-l-lg w-2 h-13 ${colorDotClassByBadgeColor(color)}`}
      ></div>
      <div
        className={classNames(
          `flex flex-1 rounded-r-lg py-2.5 pl-2 border border-gray-100 `,
          `mb-2.5 last:mb-0 w-full`,
          withOverflow ? " overflow-hidden" : "",
          className ?? ""
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default LeftBorderedContainer;
